import { render, staticRenderFns } from "./AtendimentoEnfermagemItem.vue?vue&type=template&id=1dfcf56d&scoped=true&"
import script from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoEnfermagemItem.vue?vue&type=style&index=0&id=1dfcf56d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcf56d",
  null
  
)

export default component.exports